import { useContext, useEffect, useRef } from "react";
import { FlowCanvasMenuDismissContext } from "../nodes/context";

/** Closes local dropdown state when the user clicks the Flow canvas pane.
 *  No-op in the legacy sidebar (context stays at 0). Only reacts when the
 *  signal increments — not on mount — so AddTriggerButton can start open on
 *  a fresh automation while still closing stale menus from a prior session. */
export const useFlowCanvasMenuDismiss = (dismiss: () => void): void => {
  const signal = useContext(FlowCanvasMenuDismissContext);
  const prevSignalRef = useRef(signal);
  useEffect(() => {
    if (signal > prevSignalRef.current) {
      dismiss();
    }
    prevSignalRef.current = signal;
  }, [signal, dismiss]);
};
